/**
 * Created by brunopoeta on 10/05/17.
 */

export default function SortFilter() {

    return (input, context, id, arrayAsString, defaultLabel) => {

        let output = [];

        if (!input || !input.length) {
            return output;
        }

        for (let i = 0; i < input.length; i++) {
            const item = input[i];

            if (arrayAsString) {
                if (defaultLabel === id) {
                    output.push(item);
                } else {
                    for (let j = 0; j < item[context].split(';').length; j++) {
                        if (item[context].split(';')[j] == id) {
                            output.push(item);
                            break;
                        }
                    }
                }

            } else if (!id) {
                output.push(item);
            } else if (item[context] instanceof Array) {

                for (let j = 0; j < item[context].length; j++) {
                    if (item[context][j] == id) {
                        output.push(item);
                        break;
                    }
                }

            } else if (item[context] == id) {
                output.push(item);
            }


        }

        return output;

    }

}
